<template>
  <div class="nopads">
      <!-- Header of collapsable item -->
      <div class="col-12 d-flex justify-content-between align-items-center pb-1">
          <div class="flex-grow-1">
              <h4 class="form-header pointer hover-header" @click.stop="tripDeliveriesVisible = !tripDeliveriesVisible">
                  {{ $t('daily_summary.cost_calculated') }} ({{ priceListsShown }})
              </h4>
          </div>
          <div
              v-if="loading"
              id="loader"
              class="spinner-section"
          />
          <div v-else class="ms-2 px-2" @click.stop="tripDeliveriesVisible = !tripDeliveriesVisible">
              <font-awesome-icon icon="arrow-down" class="pointer no-focus arrow-icon dont-print hover-header" :class="{ rotated:tripDeliveriesVisible }"/>
          </div>
      </div>
      <!-- Collapsable content -->
      <div class="routa-collapse" :class="{ collapsed: tripDeliveriesVisible }">
          <div v-if="tableItems && tableItems.length > 0">
              <delivery-note-order-price-list
                  v-for="(item, index) in tableItems"
                  :key="index"
                  :items="tableItems"
                  :class="'my-1 p-1 ' + index"
                  :notes="item"
                  :search-params="searchParams"
                  :summary-item="item[0]"
                  @price-list-success="setPriceListSuccess"
              />
          </div>
    </div>
    <hr class="report-divider nopads">
    <div
      v-if="loading"
      id="loader"
      class="spinner"
    />
  </div>
</template>

<script>
import {restApi} from "../mixins/RestApiMixin";
import {timeUtils} from '../mixins/TimeUtils'
import {orderMixin} from "@/components/mixins/OrderMixin";
import DeliveryNoteOrderPriceList from "@/components/materials/DeliveryNoteOrderPriceList";
import {logModes} from "@/components/mixins/VehicleMixin";


export default {
    name: "ContractReportOrderTripDeliveries",
    components: {
        DeliveryNoteOrderPriceList
    },
    mixins: [restApi, timeUtils, orderMixin, logModes],
    props: {
        searchParams: {
            type: Object,
            default() {
                return null
            }
        },
        summaryItem: {
            type: Object,
            default: null
        },
        trips: {
            type: Array,
            default() {
                return []
            }
        }
    },
    data: function () {
        return {
            loading: false,
            notes: [],
            tableItems: [],
            editedRows: [],
            priceListsShown: 0,
            tripDeliveriesVisible: false,
            tripSummaries: []
        }
    },
    watch: {
        trips() {
            this.handleTripSummaries()
        }
    },
    methods: {
        fetchDeliveryNotes: function () {
            if (this.tripSummaries && this.tripSummaries.length > 0) {
                this.loading = true
                let orderIds = []
                this.tripSummaries.forEach(tripSummary => {
                    if (tripSummary && tripSummary.order && tripSummary.order.id) {
                        if (!orderIds.includes(tripSummary.order.id)) {
                            orderIds.push(tripSummary.order.id);
                        }
                    }
                })
                let params = this.searchParams
                params.order_ids = orderIds
                params.includeTrips = 1
                this.restFetchParams(this.materialDeliveryUrl , params, this.fetchNotesSuccess, this.fetchFail)
            }
        },
        fetchNotesSuccess: function (response) {
            this.notes = response.data
            if(this.notes && this.notes.length > 0) {
                this.initTableItems()
            }
            this.loading = false
        },
        initTableItems: function () {
            this.tableItems = [];
            const orderMap = {};
            this.notes.forEach(item => {
                const orderId = item.order.id;
                if (!orderMap[orderId]) {
                    orderMap[orderId] = [];
                }
                orderMap[orderId].push(item);
            });
            Object.values(orderMap).forEach(orderArray => {
                this.tableItems.push(orderArray);
            });
        },
        editRow(row) {
            let items = []
            this.notes.forEach(note => {
                if(note.order.id === row.orderId) {
                    items.push(note)
                }
            })
            this.editedRows = items
        },
        close() {
            this.editedRows = []
        },
        handleTripSummaries() {
            if(this.trips && this.trips.length > 0) {
                this.priceListsShown = 0
                this.tripSummaries = []
                this.trips.forEach(trip => {
                    if(trip && trip.delivery_tons > 0) {
                        this.tripSummaries.push(trip)
                    }
                })
                this.fetchDeliveryNotes()
            }
        },
        setPriceListSuccess() {
            this.priceListsShown++
        },
        fetchFail: function () {
            this.loading = false
        }
    }
}
</script>
<style>
.tab-title-class {
    font-weight: bold;
}
</style>
